// export interface LoggedUser{
//     usuario: string;
//     token: string;
//     expiration:string;
// }

export interface UserResponse{
    token: string,
    user : LoggedUser
}

export interface LoggedUser{
    idpersona: number;
    iddevinvuser: number;
    netId: string;
    nombres: string;
    apellidos: string;
    codEstudiante: string;
    email: string;
    username: string;
    //tipoPersona: string;
    esinvestigacion: boolean;
    //idunidad: number;
    rolesInvestigacion:Array<rol>,
    unidadesDirectivo: rolPer,
    unidadesVicerrector: rolPer ,
    unidadesDelegado:rolPer
}

export interface rol {
    estado : string,
    idrol : number,
    idrolpersona : number,
    idunidad : number,
    nombreRol : string,
    nombreUnidad : string,
}

export interface rolPer{
    tipoPersona : string
    unidades: Array<number>
}

export function voidRolPer():rolPer{
    return{
        tipoPersona:"",
        unidades:[]
    }
}

export function GetVoidLoggedUser(): LoggedUser{
    return{
        idpersona: 0,
        iddevinvuser: 0,
        netId: '',
        nombres: '',
        apellidos: '',
        codEstudiante: '',
        email: '',
        username: '',
        //tipoPersona: '',
        esinvestigacion: false,
        //idunidad: 0,
        rolesInvestigacion:[],
        unidadesDirectivo:voidRolPer(),
        unidadesVicerrector: voidRolPer(),
        unidadesDelegado:voidRolPer()
    }
}

export function SetLoggedUser(data: any): LoggedUser{
    return{
        idpersona: data.idpersona ?? 0,
        iddevinvuser: data.iddevinvuser ?? 0,
        netId: data.netid ?? '',
        nombres: data.nombres ?? '',
        apellidos: data.apellidos ?? '',
        codEstudiante: data.codEstudiante ?? '',
        email: data.email ?? '',
        username: data.username ?? '',
        //tipoPersona: data.tipoPersona ?? '',
        esinvestigacion: data.esinvestigacion ?? false,
        //idunidad: data.idunidad ?? 0,
        rolesInvestigacion: data.rolesInvestigacion ?? [],
        unidadesDirectivo: data.unidadesDirectivo ?? voidRolPer(),
        unidadesVicerrector: data.unidadadesVicerrector ?? voidRolPer(),
        unidadesDelegado : data.unidadesDelegado ?? voidRolPer()
        
    }
}